module.exports = __webpack_public_path__ + "static/media/curon_logo.95ed58a2.svg";